import { ClientsRoutes } from './type'

const clients = `${ClientsRoutes.root}`

export const ClientsPath = {
  root: clients,
  create: `${clients}/${ClientsRoutes.create}`,
}
